import { render, staticRenderFns } from "./TeamsPage.vue?vue&type=template&id=fa1dee5e&scoped=true&"
import script from "./TeamsPage.vue?vue&type=script&lang=js&"
export * from "./TeamsPage.vue?vue&type=script&lang=js&"
import style0 from "./TeamsPage.vue?vue&type=style&index=0&id=fa1dee5e&prod&lang=scss&scoped=true&"
import style1 from "./TeamsPage.vue?vue&type=style&index=1&id=fa1dee5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1dee5e",
  null
  
)

export default component.exports